import { fetcher } from "helpers/fetcher";

import { TAddAddressReq, TAddAddressRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addAddress = async (payload: TAddAddressReq) => {
  return await fetcher<TAddAddressRes, TAddAddressReq["data"]>(
    ENDPOINT.USER.ADD_ADDRESS,
    {
      data: payload.data,
      headers: {
        [API_HEADER.USER_ID]: payload.idUser,
        [API_HEADER.VERSION]: ENDPOINT.USER.ADD_ADDRESS.version,
      },
    }
  );
};

export const mutationAddAddress = async (payload: TAddAddressReq) => {
  return (await addAddress(payload)).data.message;
};

mutationAddAddress._key = (payload: TAddAddressReq) => [
  ENDPOINT.USER.ADD_ADDRESS.url,
  payload,
];
